import { Field, Input, Textarea, Button } from "./ui";
import { formatDate, formatMoney } from "../utils/format";
import { PLAN_STATUS_LABEL } from "../utils/finance";
import { emptyPlanRow, planMatchesRemaining, planSum } from "../utils/plan";

export function InstallmentPlanEditor({
  rows,
  onChange,
  remaining,
  disabled = false,
  allowEdit = true,
}) {
  const sum = planSum(rows);
  const ok = planMatchesRemaining(rows, remaining);

  const setRow = (index, key, value) => {
    onChange(rows.map((row, rowIndex) => (rowIndex === index ? { ...row, [key]: value } : row)));
  };

  return (
    <div className={`plan-editor ${ok ? "" : "bad"}`}>
      <div className="plan-editor-head">
        <h3>Installment plan</h3>
        {allowEdit && !disabled ? (
          <Button
            variant="ghost"
            className="btn-sm"
            onClick={() => onChange([...rows, emptyPlanRow()])}
          >
            Add month
          </Button>
        ) : null}
      </div>
      <p className="muted">
        Remaining {formatMoney(remaining)} must match the plan total {formatMoney(sum)}.
      </p>
      <div className="plan-rows">
        {rows.length === 0 ? (
          <p className="muted">No remaining months. Add a month or switch to equal monthly.</p>
        ) : (
          rows.map((row, index) => (
            <div key={index} className="plan-row">
              <span>Month {index + 1}</span>
              <Input
                type="date"
                required
                disabled={disabled}
                value={row.dueDate}
                onChange={(event) => setRow(index, "dueDate", event.target.value)}
              />
              <Input
                type="number"
                min="0.01"
                step="0.01"
                required
                disabled={disabled}
                value={row.amount}
                onChange={(event) => setRow(index, "amount", event.target.value)}
                placeholder="Amount"
              />
              {allowEdit && !disabled && rows.length > 1 ? (
                <Button
                  variant="ghost"
                  className="btn-sm"
                  onClick={() => onChange(rows.filter((_, rowIndex) => rowIndex !== index))}
                >
                  Remove
                </Button>
              ) : (
                <span />
              )}
            </div>
          ))
        )}
      </div>
      {!ok ? <p className="field-error">Plan total must equal remaining.</p> : null}
    </div>
  );
}

export function InstallmentPlanTable({ plan = [] }) {
  if (!plan.length) return <p className="muted">No installment plan yet.</p>;

  return (
    <div className="plan-table">
      <div className="diff-row diff-head">
        <span>Month</span>
        <span>Due</span>
        <span>Amount</span>
        <span>Paid</span>
        <span>Status</span>
      </div>
      {plan.map((item) => (
        <div key={item.month} className={`diff-row plan-status-${item.status}`}>
          <span>{item.month}</span>
          <span>{formatDate(item.dueDate)}</span>
          <span>{formatMoney(item.amount)}</span>
          <span>{formatMoney(item.paidAmount)}</span>
          <span>{PLAN_STATUS_LABEL[item.status] || item.status}</span>
        </div>
      ))}
    </div>
  );
}

export function VendorForm({ form, onChange, onSubmit }) {
  const set = (key) => (event) => onChange({ ...form, [key]: event.target.value });

  return (
    <form id="vendor-form" className="form-grid" onSubmit={onSubmit}>
      <Field label="Vendor name">
        <Input required minLength={2} value={form.name} onChange={set("name")} placeholder="Cement store" />
      </Field>
      <Field label="Phone (optional)">
        <Input value={form.phone} onChange={set("phone")} placeholder="03xx" />
      </Field>
      <Field label="Note" wide>
        <Textarea value={form.note} onChange={set("note")} />
      </Field>
    </form>
  );
}
